import StoreForm from './component';

export default StoreForm;
